
const colors={
  primary: "#095187",
  secondary: "#9494f9ff",
  background: "#f9fafb",
  text:"#313030ff",
  gradientCyan: "linear-gradient(to right,#097EAA 0%, #5B58A6 45%, #8D2B90 65%, #A72F75 85%, #BD3961 100% )",
  gradientGreen:"linear-gradient(to right,#32A73C 0%,#61D56B 100%)",
  gradientBlue:"linear-gradient(to right,#1969B5 50%,#56ADFF 100%)",
  gradientRed:"linear-gradient(to right,#ED3237 57%,#FF5F64 100%)",
  gradientBlueWhite:"linear-gradient(to right, #3FB0FF 0%, #298CD1 50%, #2F73C2 100%)",
  gradientGreenCyan:"linear-gradient(to right, #3FB0FF 0%, #2FB93E 50%, #4EA157 100%)",
  // font:"Montserrat", sans-serif;
  // font-family:""Montserrat", sans-serif"
}
export default colors;